"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const SortSvg = (props) => {
    const { directionUp } = props;
    return (react_1.default.createElement("div", { style: { display: 'block', position: 'relative', bottom: '2px', height: '17px' } },
        react_1.default.createElement("svg", { style: { marginBottom: '-18px' }, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "24", height: "24" },
            react_1.default.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
            react_1.default.createElement("path", { fill: directionUp ? '#5F673B' : '#403E3C3B', d: "M12 10l4 4H8z" })),
        react_1.default.createElement("svg", { style: { marginTop: '-18px' }, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "24", height: "24" },
            react_1.default.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
            react_1.default.createElement("path", { fill: directionUp ? '#403E3C3B' : '#5F673B', d: "M12 14l-4-4h8z" }))));
};
SortSvg.defaultProps = {
    directionUp: false,
};
SortSvg.propTypes = {
    directionUp: prop_types_1.default.bool,
};
exports.default = SortSvg;
